module.exports = __webpack_public_path__ + "static/bg-masthead-bab61b6c95928b32666d025ee5eddac8.jpg";